import { type FC } from 'react';
import { Box, Chip, Stack, Typography } from '@mui/material';
import { Login } from '@mui/icons-material';

export type GuestUserProps = {
  /**
   * Callback function when the sign in button is clicked.
   */
  onSignInClick: () => void;
};

export const GuestUser: FC<GuestUserProps> = ({ onSignInClick }) => (
  <Box sx={{ px: 1, mt: 1 }}>
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Typography variant="body2">Not Signed In?</Typography>
      <Chip
        label="Sign In"
        variant="outlined"
        size="small"
        icon={<Login fontSize="small" />}
        onClick={onSignInClick}
      />
    </Stack>
    <Typography
      component="div"
      variant="subtitle2"
      color="warning"
      sx={{ mt: 0.5 }}>
      (You may lose your data if you are not logged in)
    </Typography>
  </Box>
);
